export const aboutCopy = `<p>
at <strong>revive renoworks</strong>, precision installs are what set us apart. from exacting design specifications and custom cabinetry installs in a kitchen, to one off custom stone vanities and high end carpentry installs, we believe the renovation magic is how these details are executed and all come together seamlessly.
</p>`

export const igLink = "https://www.instagram.com/revive_renoworks/"

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "@id": "https://reviverenoworks.com/#business",
  name: "revive renoworks",
  url: "https://reviverenoworks.com/",
  description:
    "Premium home remodeling specializing in kitchens and bathrooms across Atlanta and North Georgia.",
  telephone: "(770) 689-7407",
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Marietta",
    addressRegion: "GA",
    addressCountry: "US",
  },
  areaServed: [
    { "@type": "City", name: "Atlanta" },
    { "@type": "AdministrativeArea", name: "Buckhead" },
    { "@type": "City", name: "Smyrna" },
    { "@type": "AdministrativeArea", name: "Historic Brookhaven" },
    { "@type": "City", name: "Dallas" },
    { "@type": "City", name: "Kennesaw" },
    { "@type": "City", name: "Acworth" },
    { "@type": "City", name: "Marietta" },
  ],
  image: "https://reviverenoworks.com/images/grid/8.jpg",
}

export const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  provider: {
    "@id": "https://reviverenoworks.com/#business",
  },
  name: "Remodeling Services by revive renoworks",
  itemListElement: [
    {
      "@type": "Service",
      name: "Kitchen Remodeling",
      serviceType: "Home Improvement",
      description:
        "Full-service kitchen transformations including custom cabinetry, countertops, lighting, and layout re-design.",
      provider: { "@type": "LocalBusiness", name: "revive renoworks" },
      areaServed: { "@type": "State", name: "GA" },
    },
    {
      "@type": "Service",
      name: "Bathroom Renovation",
      serviceType: "Home Improvement",
      description:
        "Professional bathroom remodeling from master suites to powder rooms, specializing in walk-in showers and tile work.",
      provider: { "@type": "LocalBusiness", name: "revive renoworks" },
      areaServed: { "@type": "State", name: "GA" },
    },
    {
      "@type": "Service",
      name: "Basement Finishing",
      serviceType: "Home Improvement",
      description:
        "Turning underutilized basements into functional living spaces, home offices, or entertainment suites.",
      provider: { "@type": "LocalBusiness", name: "revive renoworks" },
      areaServed: { "@type": "State", name: "GA" },
    },
  ],
}
